import { css } from "styled-components";

import { Style } from "../Button.types";

const fill = css`
  --button-color: ${props => props.theme.palette.white};
  --button-border-color: transparent;
  --button-background-color: ${props => props.theme.palette.blue500};

  &:hover {
    --button-background-color: ${props => props.theme.palette.blue600};
  }

  &:active {
    --button-background-color: ${props => props.theme.palette.blue400};
  }

  &:focus:not(:hover, :active) {
    --button-border-color: ${props => props.theme.palette.blue800};
    --button-background-color: ${props => props.theme.palette.blue600};
  }
`;

const stroke = css`
  --button-color: ${props => props.theme.palette.blue500};
  --button-border-color: ${props => props.theme.palette.blue500};
  --button-background-color: transparent;

  &:hover {
    --button-color: ${props => props.theme.palette.blue600};
    --button-border-color: ${props => props.theme.palette.blue600};
    --button-background-color: ${props => props.theme.palette.blue20};
  }

  &:active {
    --button-background-color: ${props => props.theme.palette.blue50};
  }

  &:focus:not(:hover, :active) {
    --button-border-color: ${props => props.theme.palette.blue800};
    --button-background-color: ${props => props.theme.palette.blue20};
  }
`;

const text = css`
  --button-color: ${props => props.theme.palette.blue500};
  --button-border-color: transparent;
  --button-background-color: transparent;

  &:hover {
    --button-color: ${props => props.theme.palette.blue600};
  }

  &:active {
    --button-background-color: ${props => props.theme.palette.blue50};
  }

  &:focus:not(:hover, :active) {
    --button-border-color: ${props => props.theme.palette.blue800};
    --button-background-color: ${props => props.theme.palette.blue20};
  }
`;

export const getBlueVariant = (style: Style) => css`
  &:disabled {
    --button-color: ${props => props.theme.palette.grey300};
    --button-border-color: ${props => props.theme.palette.grey100};
    --button-background-color: ${props => props.theme.palette.grey100};
  }

  ${style === "fill" && fill}

  ${style === "stroke" && stroke}

  ${style === "text" && text}
`;
